import { IApiErrorParams, ApiErrorCode } from '../apiError.interface';
import { isApiError } from './isApiError';

export const handleApiError = <T extends IApiErrorParams>(error: unknown): T | undefined => {
  if (isApiError<T>(error)) {
    return {
      status: error.status ?? 0,
      errorCode: ApiErrorCode.UnknownError,
      ...error.response?.data?.error,
    } as T;
  }

  return undefined;
};
